import { SpeedDial, SpeedDialAction, SpeedDialIcon } from "@mui/material";
import { ThemeContext, AuthContext } from "../../../../contexts";
import { useEffect, useContext, useState, useCallback, Suspense, useRef } from "react";
import { useReactToPrint } from "react-to-print";
import { LazyCustomFormDialog } from "../../../shared";
import { url, port } from "../../../../config/config";

import DownloadIcon from "@mui/icons-material/Download";
import AttachEmailIcon from "@mui/icons-material/AttachEmail";
import HealthCardPrint from "./clinicCardPrint/ClinicCardPrint";
import { api } from "../../../../utils/api";

import "./clinicCard.css";
import axios from "axios";
import CustomEmailDialog from "./customEnterEmailDialog/CustomEmailDialog";
import ClinicCardPrintV2 from "./clinicCardPrint/ClinicCardPrintV2";
import ClinicCardActualV2 from "./clinicCardActual/ClinicCardActualV2";
import ClinicCardActualV3 from "./clinicCardActual/ClinicCardActualV3";
import ClinicCardPrintV3 from "./clinicCardPrint/ClinicCardPrintV3";
import ClinicCardActualV4 from "./clinicCardActual/ClinicCardActualV4";
import ClinicCardPrintV4 from "./clinicCardPrint/ClinicCardPrintV4";

const _email = "";
const token = localStorage.getItem("@jwt_member");
const apiUrl = `${url}:${port}` + "/api/v1/member/health-card";

interface ClinicCardProps {
	planName: string;
}

const ClinicCard = ({ planName }: ClinicCardProps) => {
	const [openSpeedDial, setOpenSpeedDial] = useState(false);
	const [hasHealthPlan, setHasHealthPlan] = useState(null);
	const [enteredEmail, setEnteredEmail] = useState("");
	const [customEmailFormDialogProps, setCustomEmailFormDialogProps] = useState({
		openDialog: false,
		title: "Email Health Card",
		actions: [
			{
				label: "Cancel",
				callback: () => {
					setCustomEmailFormDialogProps(Object.assign({}, customEmailFormDialogProps, { openDialog: false }));
				}
			}
			// {
			// 	label: "Submit",
			// 	callback: () => {
			// 		api.healthCard.emailHealthCard(enteredEmail);
			// 		setCustomEmailFormDialogProps(Object.assign({}, customEmailFormDialogProps, { openDialog: false }));
			// 	}
			// }
		]
	});
	// const [enteredEmail, setEnteredEmail] = useState("");
	const { theme } = useContext(ThemeContext);
	const { member } = useContext(AuthContext);
	const componentRef = useRef(null);
	const handlePrint = useReactToPrint({
		content: () => componentRef.current
	});
	const speedDialActions = [
		{
			name: <div className="tooltip-speed-dial">Download</div>,
			icon: <DownloadIcon />,
			actionName: "download_brochure"
		},
		{
			name: <div className="tooltip-speed-dial">Email</div>,
			icon: <AttachEmailIcon />,
			actionName: "email_brochure"
		}
	];

	const handleOpenSpeedDial = () => setOpenSpeedDial(true);

	const handleCloseSpeedDial = () => setOpenSpeedDial(false);

	// eslint-disable-next-line arrow-parens
	const handleEnterEmailChange = useCallback(
		// eslint-disable-next-line arrow-parens
		(event) => {
			const { value } = event.target;
			setEnteredEmail(value);
		},
		[]
	);

	const emailHealthCardHandler = useCallback(async () => {
		const emailHealthcardQuery = {
			email: enteredEmail,
			group_number: member.group_number,
			plan_name: planName
		};
		const response = await api.healthCard.emailHealthCard(emailHealthcardQuery);
		alert(response);
		setCustomEmailFormDialogProps(Object.assign({}, customEmailFormDialogProps, { openDialog: false }));
	}, [customEmailFormDialogProps, enteredEmail, member]);

	const getMemberEmail = useCallback(() => {
		if (
			member &&
			(member.email !== "" ||
				member.email !== "email@email.com" ||
				member.email !== null ||
				member.email !== undefined)
		) {
			setEnteredEmail(member.email);
		} else {
			setEnteredEmail("");
		}
	}, [member]);

	const handleOpenEnterEmailDialog = useCallback(() => {
		setCustomEmailFormDialogProps(Object.assign({}, customEmailFormDialogProps, { openDialog: true }));
	}, [customEmailFormDialogProps]);

	const getActiveHealthPlan = useCallback(async () => {
		const healthPlan = await api.enrollment.getActiveHealthPlan();
		if (healthPlan) {
			setHasHealthPlan(true);
		} else {
			setHasHealthPlan(false);
		}
	}, []);

	useEffect(() => {
		getActiveHealthPlan();
	}, [getActiveHealthPlan]);

	useEffect(() => {
		if (member) {
			getMemberEmail();
		}
	}, [getMemberEmail, member]);

	// console.log("member", member);
	// console.log("email", enteredEmail);
	// console.log(customEmailFormDialogProps);

	return (
		<>
			<Suspense fallback={<div />}>
				<CustomEmailDialog
					customEmailFormDialogProps={customEmailFormDialogProps}
					enteredEmail={enteredEmail}
					setEnteredEmail={setEnteredEmail}
					emailHealthCardHandler={emailHealthCardHandler}
					// handleEnterEmailChange={handleEnterEmailChange}
				/>
			</Suspense>
			<SpeedDial
				ariaLabel="SpeedDial tooltip example"
				className="speed-dial"
				icon={<SpeedDialIcon />}
				sx={{ position: "fixed", bottom: 16, right: 16 }}
				onClose={handleCloseSpeedDial}
				onOpen={handleOpenSpeedDial}
				open={openSpeedDial}
				FabProps={{
					style: {
						backgroundColor: theme?.primary_color
					}
				}}
			>
				{speedDialActions.map((action, index) => {
					const { name, icon, actionName } = action;
					return (
						<SpeedDialAction
							key={index}
							icon={icon}
							tooltipTitle={name}
							tooltipOpen
							onClick={actionName === "download_brochure" ? handlePrint : handleOpenEnterEmailDialog}
						/>
					);
				})}
			</SpeedDial>
			{/* <HealthCardActual /> */}
			<ClinicCardActualV4 />
			<div style={{ display: "none" }}>
				<Suspense fallback={<div />}>
					{member ? (
						<ClinicCardPrintV4
							// props={[]}
							props={member}
							ref={componentRef}
							first_name={member.first_name.toUpperCase()}
							last_name={member.last_name.toUpperCase()}
							_ssn={member?.SSN}
							group_number={member.group_number}
						/>
					) : null}
				</Suspense>
			</div>
		</>
	);
};

export default ClinicCard;
